<template>
    <v-container class="welcome">
        <video autoplay muted loop playsinline class="bg-video">
            <source src="@/assets/background.mp4" type="video/mp4" />
        </video>
        <div class="welcome-message scale-up-center">
            <fibryo-logo v-if="isWhitelabel" class="fibryo-logo-lg company-logo" :color="theming.cardsAndTablesText" />
            <v-img v-else width="450px" class="company-logo" contain :src="require(`@/assets/companies/${companyName}.png`)" />
            <span class="mt-2">Καλώς ήρθες στην Πλατφόρμα Ανάθεσης Έργου</span>
        </div>
        <div v-if="!isWhitelabel" class="brand scale-up-center">
            <span>powered by</span>
            <fibryo-logo class="fibryo-logo" :color="theming.cardsAndTablesText" />
        </div>
    </v-container>
</template>
<script>
    import FibryoLogo from '@/components/FibryoLogoSVG'

    const COMPANY_NAME = process.env.VUE_APP_ENV_COMPANY_NAME

    export default {
        components: { FibryoLogo },
        computed: {
            companyName() {
                return COMPANY_NAME
            },
            theming() {
                return this.$store.getters.getTheming || {}
            },
            isWhitelabel() {
                return this.companyName === 'fibryo'
            }
        }
    }
</script>
<style scoped>
.scale-up-center{animation:scale-up-center .4s cubic-bezier(.39,.575,.565,1.000) both}
@keyframes scale-up-center{0%{transform:scale(.5)}100%{transform:scale(1)}}
.bg-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 1;
}
.welcome-message, .brand {
    z-index: 2;
}
.fibryo-logo-lg {
    max-width: 450px;
}
.fibryo-logo {
    width: 150px;
}
.company-logo {
    margin: 0 auto;
}
.welcome {
    display: flex;
    height: 90vh;
    flex-direction: column;
    align-items: space-between;
    color: var(--cards-and-tables-text-color) !important;
}
.brand {
    width: 100%;
    font-style: italic;
    font-weight: 400;
    font-size: 0.8rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
}
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;;
}

.welcome-message {
    font-size: calc(1vw + 2vh);
    font-weight: bold;
    display: flex;
    flex-direction: column;
    max-width: 100%;
    text-align: center;
    /*
    align-content: center;
    font-weight: bold;
    font-size: calc(1vw + 2vh);
    height: 50%;
    max-width: 100%; */
}

</style>
